import { useTranslation } from "react-i18next";
import React, { useEffect } from 'react';
import Axios from "../../../Axios";

const ConfirmPopup = ({ show, setShowPopupConfirm, getMaxPage, setNbPage, getUsers, infoUser, setNbUserShow }) => {
    const { t } = useTranslation();

    const deleteGroup = async () => {
        try {
            const response = await Axios.delete(`/api/users/?id=${infoUser.id}`, {
                headers: {
                    "auth-token": sessionStorage.getItem('token')
                },
                withCredentials: true
            });
            if (response.status === 200) {
                setNbUserShow(20);
                getMaxPage();
                setNbPage(1);
                getUsers();
            } else {
                alert(t("Delete failed"));
            }
        } catch (error) {
            console.error("Error during delete:", error);
        }

    }

    const handleConfirm = () => {
        setShowPopupConfirm(false);
        deleteGroup();
    };

    const handleClose = () => {
        setShowPopupConfirm(false);
    };

    if (!show) return null;

    return (
        <div id="modal-bg" className="fixed z-40 inset-0 bg-gray-600 bg-opacity-30 flex items-center justify-center" onClick={event => {
            if (event.target.id === 'modal-bg') {
                handleClose()
            }
        }}>
            <div id='modal-bg' className="bg-white p-5 rounded shadow-lg w-1/3">
                <h2 className="text-lg font-semibold">{t('delete user title') + " (" + infoUser.firstname + " " + infoUser.lastname.toUpperCase() + ")"}</h2>
                <p className="mt-2">{
                    t('delete user text')
                }</p>
                <div className="flex flex-row justify-between mt-4">
                    <button className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
                        onClick={handleConfirm}>
                        {t('delete')}
                    </button>
                    <button className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
                        onClick={handleClose}>
                        {t('cancel')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmPopup;